import {KpiCalculationError} from '@hconnect/common/types'
import {Gauge} from '@hm/fundamental'
import {Box} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {EXPERT_SYSTEM_WIDGET_NAMESPACE, VALIDATION_TRANSLATIONS_KEY} from '../consts'
import type {EquipmentExpertSystemUsage} from '../types'

export const ExpertSystemEquipmentCharts: React.FC<{
  expertSystemEquipments: EquipmentExpertSystemUsage[]
}> = ({expertSystemEquipments}) => {
  const {t} = useTranslation(EXPERT_SYSTEM_WIDGET_NAMESPACE)

  return (
    <Box display="flex" sx={{flexWrap: 'wrap', maxHeight: '50%', gap: 4}}>
      {expertSystemEquipments.map(({hierarchyId, name, value, kpiCalculationError}) => (
        <span key={hierarchyId} data-test-id={`expert-system-eq-${hierarchyId}`}>
          <Gauge
            {...(kpiCalculationError &&
            kpiCalculationError !== KpiCalculationError.EquipmentNotRunning
              ? {
                  emptyStateMessage: t(VALIDATION_TRANSLATIONS_KEY[kpiCalculationError])
                }
              : {
                  value: kpiCalculationError
                    ? t(VALIDATION_TRANSLATIONS_KEY[kpiCalculationError])
                    : Math.round(value)
                })}
            label={name}
            enableTooltip={false}
          />
        </span>
      ))}
    </Box>
  )
}
